// 🆕 Modale condiviso per la gestione dell'elenco DIETE/INTOLLERANZE.
// Usato da Mensa Giorno e Mensa Matrice. Persiste in app_settings.mensa_diete.
import { useState } from "react";
import api from "@/lib/api";

export default function DieteManagerModal({ items, onSaved, onClose }) {
  const [list, setList] = useState([...(items || [])]);
  const [nuova, setNuova] = useState("");
  const [saving, setSaving] = useState(false);
  // 🆕 Feb 2026: Import Storico Intolleranze XLSX (una-tantum) — colonne C01/C02/id Alunno
  const [importMsg, setImportMsg] = useState(null);
  const [importing, setImporting] = useState(false);
  const [importAnno, setImportAnno] = useState(2025);
  const doImportStorico = async (file) => {
    if (!file) return;
    if (!window.confirm(`Importare le intolleranze STORICHE dell'anno ${importAnno}/${String(importAnno + 1).slice(-2)}?\n\nQuesta operazione è idempotente e va effettuata una sola volta per l'archivio storico.\nGli inserimenti dell'anno corrente vanno fatti a mano dalla Matrice Mensa.`)) return;
    setImporting(true); setImportMsg(null);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post(`/mensa-matrice/intolleranze/import-storico?anno=${importAnno}`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const d = r.data || {};
      setImportMsg({
        ok: true,
        text: `✓ Import ${d.anno}: ${d.inserted} nuove · ${d.updated} aggiornate · ${d.skipped} saltate` + (d.not_found_count ? ` · ${d.not_found_count} alunni non trovati` : ""),
      });
    } catch (e) {
      setImportMsg({ ok: false, text: `Errore import: ${e.response?.data?.detail || e.message}` });
    } finally { setImporting(false); }
  };

  const move = (idx, dir) => {
    const arr = [...list];
    const t = idx + dir;
    if (t < 0 || t >= arr.length) return;
    [arr[idx], arr[t]] = [arr[t], arr[idx]];
    setList(arr);
  };
  const addNuova = () => {
    const s = nuova.trim();
    if (s && !list.some(x => x.toLowerCase() === s.toLowerCase())) {
      setList([...list, s]); setNuova("");
    }
  };
  const salva = async () => {
    setSaving(true);
    try {
      const r = await api.put("/mensa/giorno/diete", { items: list });
      onSaved && onSaved(r.data?.items || list);
      onClose();
    } catch (e) {
      alert(`Errore: ${e.response?.data?.detail || e.message}`);
    } finally { setSaving(false); }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 900, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div onClick={e => e.stopPropagation()} data-testid="diete-manager-modal"
        style={{ background: "white", width: "100%", maxWidth: 480, borderRadius: 6, overflow: "hidden", maxHeight: "85vh", display: "flex", flexDirection: "column" }}>
        <div style={{ background: "#1a237e", color: "white", padding: "12px 18px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <strong>🍽 Gestione Diete/Intolleranze</strong>
          <button onClick={onClose} data-testid="diete-close" style={{ background: "none", border: "none", color: "white", cursor: "pointer", fontSize: 18 }}>✕</button>
        </div>
        <div style={{ padding: 16, overflowY: "auto", flex: 1 }}>
          <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
            <input value={nuova} onChange={e => setNuova(e.target.value)}
              placeholder="Nuova dieta (es. No lievito)"
              data-testid="diete-input-nuova"
              onKeyDown={e => { if (e.key === "Enter") addNuova(); }}
              style={{ flex: 1, padding: "6px 8px", border: "1px solid #ccc", fontSize: 12 }} />
            <button onClick={addNuova}
              data-testid="diete-add"
              style={{ padding: "6px 14px", background: "#2e7d32", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>+ Aggiungi</button>
          </div>
          <div style={{ border: "1px solid #eee", borderRadius: 3 }}>
            {list.length === 0 && <div style={{ padding: 20, textAlign: "center", color: "#999", fontStyle: "italic" }}>Nessuna dieta configurata</div>}
            {list.map((d, i) => (
              <div key={`${d}-${i}`} data-testid={`diete-row-${i}`}
                style={{ padding: "6px 10px", borderBottom: "1px solid #eee", display: "flex", alignItems: "center", gap: 6, background: i % 2 ? "#fafafa" : "white" }}>
                <span style={{ flex: 1, fontSize: 12, fontWeight: 600 }}>{d}</span>
                <button onClick={() => move(i, -1)} disabled={i === 0} title="Sposta su"
                  style={{ background: i === 0 ? "#eee" : "#607d8b", color: i === 0 ? "#999" : "white", border: "none", padding: "2px 6px", fontSize: 10, cursor: i === 0 ? "not-allowed" : "pointer" }}>▲</button>
                <button onClick={() => move(i, 1)} disabled={i === list.length - 1} title="Sposta giù"
                  style={{ background: i === list.length - 1 ? "#eee" : "#607d8b", color: i === list.length - 1 ? "#999" : "white", border: "none", padding: "2px 6px", fontSize: 10, cursor: i === list.length - 1 ? "not-allowed" : "pointer" }}>▼</button>
                <button onClick={() => setList(list.filter((_, k) => k !== i))} data-testid={`diete-del-${i}`}
                  title="Rimuovi" style={{ background: "#c62828", color: "white", border: "none", padding: "2px 6px", fontSize: 10, cursor: "pointer" }}>🗑</button>
              </div>
            ))}
          </div>

          {/* 🆕 Feb 2026: Import Storico XLSX (una-tantum) */}
          <div style={{ marginTop: 18, padding: 12, background: "#fff8e1", border: "1.5px solid #f9a825", borderRadius: 4 }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: "#e65100", marginBottom: 6 }}>
              📥 Import Storico Intolleranze (XLSX)
            </div>
            <div style={{ fontSize: 10, color: "#5d4037", marginBottom: 8, lineHeight: 1.4 }}>
              Import <b>una-tantum</b> dell'archivio storico. Formato colonne: <code>Anno</code>, <code>C01</code>, <code>C02</code>, <code>id Alunno</code>. Se in anno corrente manca il certificato, la matrice mostrerà comunque quello dell'anno precedente con un badge di segnalazione.
            </div>
            <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
              <label style={{ fontSize: 10, fontWeight: 700, color: "#5d4037" }}>Anno di riferimento:</label>
              <input type="number" value={importAnno} onChange={e => setImportAnno(Number(e.target.value) || 2025)}
                data-testid="diete-import-anno"
                style={{ width: 80, padding: "4px 6px", border: "1px solid #f9a825", fontSize: 11, fontWeight: 700, background: "white" }} />
              <label htmlFor="diete-import-file" data-testid="diete-import-file-label"
                style={{ padding: "5px 12px", background: importing ? "#bdbdbd" : "#e65100", color: "white", fontSize: 11, fontWeight: 700, cursor: importing ? "wait" : "pointer", borderRadius: 3 }}>
                {importing ? "Import in corso…" : "📎 Scegli file XLSX"}
              </label>
              <input id="diete-import-file" type="file" accept=".xlsx"
                data-testid="diete-import-file"
                disabled={importing}
                onChange={e => { const f = e.target.files?.[0]; if (f) doImportStorico(f); e.target.value = ""; }}
                style={{ display: "none" }} />
            </div>
            {importMsg && (
              <div data-testid="diete-import-msg"
                style={{ marginTop: 8, padding: "6px 10px", borderRadius: 3, fontSize: 11, fontWeight: 700,
                         background: importMsg.ok ? "#c8e6c9" : "#ffcdd2",
                         color: importMsg.ok ? "#1b5e20" : "#b71c1c" }}>
                {importMsg.text}
              </div>
            )}
          </div>
        </div>
        <div style={{ padding: "12px 18px", background: "#f5f5f5", display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button onClick={onClose} data-testid="diete-cancel"
            style={{ padding: "8px 16px", background: "white", border: "1px solid #ccc", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Annulla</button>
          <button onClick={salva} disabled={saving} data-testid="diete-save"
            style={{ padding: "8px 16px", background: saving ? "#bdbdbd" : "#1a237e", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: saving ? "wait" : "pointer" }}>{saving ? "Salvo..." : "Salva"}</button>
        </div>
      </div>
    </div>
  );
}
